import { onUnmounted, ref, watch } from 'vue';
import { useQueryParams } from '~/composables/useQueryString';

export const useDebouncedFetchParams = <T extends object>(defaultFilters: T = {} as T) => {
    const loading = ref(true);
    const debouncedFetchParams = ref<T>();

    let loadingTimeout: ReturnType<typeof setTimeout>;
    let fetchParamsTimeout: ReturnType<typeof setTimeout>;

    const fetchParams = useQueryParams<T>({
        initialValue: defaultFilters,
    });

    watch(
        fetchParams,
        () => {
            clearTimeout(loadingTimeout);
            clearTimeout(fetchParamsTimeout);

            const debounceDuration = 600;

            fetchParamsTimeout = setTimeout(() => {
                debouncedFetchParams.value = JSON.parse(JSON.stringify(fetchParams));
            }, debounceDuration);

            loading.value = true;
            loadingTimeout = setTimeout(() => {
                loading.value = false;
            }, debounceDuration + 300);
        },
        {
            deep: true,
            immediate: true,
        }
    );

    onUnmounted(() => {
        clearTimeout(loadingTimeout);
        clearTimeout(fetchParamsTimeout);
    });

    const resetFilters = () => {
        Object.assign(fetchParams, defaultFilters);
    };

    return {
        fetchParams,
        loading,
        debouncedFetchParams,
        resetFilters,
    };
};
